import { API_URLS } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import Button from '@stories/Components/Buttons/Button/Button';
import MemberCard from '@stories/Components/Cards/HTAMemberCard/HTAMemberCard';
import SupporterCard from '@stories/Components/Cards/HTASupporterCard/HTASupporterCard';
import FilteredListing from '@stories/Components/FilteredListing/FilteredListing';
import HTAMemberSearch from '@stories/Components/HTAMemberSearch/HTAMemberSearch';
import RichText from '@stories/Widgets/RichText/RichText';
import queryString from 'query-string';
import React from 'react';
import { useFirstMountState } from 'react-use';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import S from './HTAMemberListing.styles';
const MemberListing = ({ 
// mapData,
buttonThemeOption, errorText, filterTitle, initialData, listingType, searchProps, typeFilter, pageIntro, sustainabilityLink, }) => {
    const isFirstMount = useFirstMountState();
    const isSupportersListing = listingType === 'supporters';
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        name: StringParam,
        location: StringParam,
        pageIndex: NumberParam,
        pageIndexFullSupport: NumberParam,
        type: StringParam,
    });
    // Create filter value structure.
    const filterValue = {
        type: queryParams.type ?? '',
    };
    // Get additional filters.
    const name = queryParams.name ?? '';
    const location = queryParams.location ?? '';
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    const pageIndexFullSupport = queryParams.pageIndexFullSupport ?? 1;
    // Construct API url.
    const parameters = queryString.stringify({
        name: name,
        location: location,
        pageIndex: pageIndex,
        pageSize: isSupportersListing ? 8 : 12,
        type: filterValue.type,
    });
    const supportersParameters = queryString.stringify({
        name: name,
        location: location,
        pageIndex: pageIndex,
        pageIndexFullSupport: pageIndexFullSupport,
        pageSize: isSupportersListing ? 8 : 12,
        pageSizeFullSupport: 4,
        type: filterValue.type,
        isSupporter: isSupportersListing,
    });
    /**
     * Store inital parameters so API call is only enabled when parameters change, otherwise
     * call fires off when isFirstMount becomes false, when initialData should still be used
     *
     * This will be cleared the first time params change to ensure resetting filters still
     * triggers an API call
     */
    const [initialParams, setInitialParams] = React.useState(isSupportersListing ? supportersParameters : parameters);
    const apiUrl = isSupportersListing
        ? `${API_URLS.supportersFull}&${supportersParameters}`
        : `${API_URLS.members}?${parameters}`;
    const apiUrlProv = isSupportersListing
        ? `${API_URLS.supportersProv}&${supportersParameters}`
        : '';
    React.useEffect(() => {
        if (initialParams !== (isSupportersListing ? supportersParameters : parameters) &&
            initialParams !== '') {
            setInitialParams('');
        }
    }, [parameters]);
    // Fetch data.
    const { data, loading, error } = useApi(apiUrl, !isFirstMount && initialParams !== (isSupportersListing ? supportersParameters : parameters));
    const { data: dataProv, loading: loadingProv, error: errorProv, } = useApi(apiUrlProv, !isFirstMount && initialParams !== (isSupportersListing ? supportersParameters : parameters));
    // Get items from response or initial items.
    const items = dataProv?.items ?? initialData.provisionalSupporters;
    const itemsSupportFull = data?.items ?? (isSupportersListing ? initialData.fullSupporters : initialData.items);
    const totalItems = dataProv?.totalItems ??
        (isSupportersListing ? initialData.provisionalSupportersTotal : initialData.totalItems);
    const totalItemsFull = data?.totalItems ?? initialData.fullSupportersTotal;
    const fullStatus = isSupportersListing ? itemsSupportFull : [];
    const provisionalStatus = isSupportersListing ? items : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(HTAMemberSearch, { ...searchProps, nameValue: name, locationValue: location, onLocationChange: (value) => setQueryParams({ location: value }), onNameChange: (value) => setQueryParams({ name: value }) }),
        pageIntro && (React.createElement(RichText, { content: pageIntro, width: "narrow", align: "left", leadParagraphWide: true, leadParagraphBold: true })),
        React.createElement(FilteredListing, { errorText: errorText, buttonThemeOption: buttonThemeOption, error: error, filtersProps: {
                filters: [typeFilter],
                filterValue: filterValue,
                title: filterTitle,
                onFilterChange: (key, val) => {
                    setQueryParams({ [key]: val, pageIndex: 1, pageIndexFullSupport: 1 });
                },
            }, items: itemsSupportFull, fullItems: fullStatus, provisionalItems: provisionalStatus, isSupportersListing: isSupportersListing, loading: loading, loadingProv: loadingProv, pageIndex: pageIndex, renderItems: (items, fullItems, provisionalItems, isSupportersListing) => isSupportersListing ? (React.createElement(React.Fragment, null,
                React.createElement(S.ItemList, null,
                    React.createElement(S.ItemListHeader, null, "Full Supporters"),
                    fullItems.length ? (fullItems.map((item) => (React.createElement(S.Item, { key: item.id, spanColumns: 4 },
                        React.createElement(SupporterCard, { ...item }))))) : (React.createElement(S.Message, null, "No results found"))),
                errorProv && React.createElement(S.Message, null, errorProv.message),
                fullItems.length < (totalItemsFull ? totalItemsFull : 0) && (React.createElement(S.CtaWrapper, null,
                    React.createElement(Button, { themeOption: buttonThemeOption, title: "Load More", onClick: (event) => {
                            event.preventDefault();
                            // Remove focus state from button after click, as it looks disabled
                            event.currentTarget.blur();
                            const newIndex = pageIndexFullSupport + 1;
                            setQueryParams({ pageIndexFullSupport: newIndex });
                        } }))),
                React.createElement(S.ItemList, null,
                    React.createElement(S.ItemListHeader, null, "Provisional Supporters"),
                    provisionalItems.length ? (provisionalItems.map((item) => (React.createElement(S.Item, { key: item.id, spanColumns: 4 },
                        React.createElement(SupporterCard, { ...item }))))) : (React.createElement(S.Message, null, "No results found"))))) : (React.createElement(S.ItemList, null, items.map((item) => (React.createElement(S.Item, { key: item.id, spanColumns: 3 },
                React.createElement(MemberCard, { ...item, sustainabilityLink: sustainabilityLink })))))), totalItems: totalItems, onPageChange: (pageIndex) => {
                setQueryParams({ pageIndex });
            } })));
};
export default withQueryParams(MemberListing);
